import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { UnmountClosed } from "react-collapse";

import Tools from "./Tools";
import ThemeSettings from "./ThemeSettings";
import ElementsBar from "./ElementsBar";

const LeftSidebar = props => {
  const [active, setActive] = useState("tools");
  const [collapsedColumns, setCollapsedColumns] = useState(true);

  const tabClasses = tab => {
    return classNames({ active: active === tab });
  };

  const toggleElementsBar = () => {
    active === 'elements' ? setActive('tools') : setActive('elements');
  };

  const elements = active === 'elements';

  const sidebarClasses = classNames(
    `fantastic-sidebar fantastic-sidebar--left fantastic-sidebar--left-${active}`,
    {
      "fantastic-sidebar--active-elements-bar": elements,
      "fantastic-sidebar--left-big": !collapsedColumns
    }
  );
  const creatorMode = props.settings && props.settings.creator_mode;
  const adminMode = props.settings && props.settings.admin_mode;

  const elementsBarClasses = classNames("fantastic-elements-bar", {
    "fantastic-elements-bar--active": elements
  });

  return (
    <>
      <div className={sidebarClasses}>
        <div className="fantastic-sidebar__wrapper">
          <ul className="fantastic-tabs">
            <li
              onClick={() => setActive("tools")}
              className={tabClasses("tools")}
            >
              <a>{ i18n.t('content') }</a>
            </li>
            <li
              onClick={() => setActive("theme_settings")}
              className={tabClasses("theme_settings")}
            >
              <a>{ i18n.t('settings') }</a>
            </li>
          </ul>
          {active == "tools" && (
            <>
              <Tools
                creatorMode={creatorMode}
                adminMode={adminMode}
                toggleElements={toggleElementsBar}
                onCollapsed={(i) => setCollapsedColumns(i)}
              />
            </>
          )}
          {active == "theme_settings" && (
            <ThemeSettings creatorMode={creatorMode} />
          )}
        </div>
      </div>
      <div className={elementsBarClasses}>
        <UnmountClosed isOpened={elements}>
          <ElementsBar handleClose={() => toggleElementsBar()} />
        </UnmountClosed>
      </div>
    </>
  );
};
export default LeftSidebar;
